'use strict';

import {addClass} from "../helpers";

export const changeH2ToH3 = () => {
  const _app = document.getElementById('app');
  if (_app.dataset['page'] === 'services' || _app.dataset['page'] === 'service_single') {
    _app.querySelectorAll('.txt__block h2').forEach(h2 => {
      addClass(h2, 'h3');
    });
  }
};
